module.exports = __webpack_public_path__ + "img/spinner.7a79dfd4.svg";